export abstract class LogAppenderProvider {
    public abstract debug(logger, message, ...rest);
    public abstract info(logger, message, ...rest);
    public abstract warn(logger, message, ...rest);
    public abstract error(logger, message, ...rest);
}